import { createContext } from "react";
import { Customer } from "./shared/customer";
import { Reservation } from "./shared/reservation";

export const CustomerContext = createContext<Customer>(null!);

export const ReservationsContext = createContext<Reservation[]>([]);